import React from "react";

const MemberModal = ({
  showModal,
  selectedMember,
  mallId,
  shopNo,
  onClose,
  formatPhoneNumber,
}) => {
  if (!showModal || !selectedMember) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        padding: "20px",
      }}
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "16px",
          boxShadow: "0 20px 60px rgba(0, 0, 0, 0.25)",
          maxWidth: "1080px",
          width: "100%",
          maxHeight: "90vh",
          overflow: "auto",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* 헤더 */}
        <div
          style={{
            padding: "24px 32px",
            borderBottom: "1px solid #e2e8f0",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "#f8fafc",
            borderRadius: "16px 16px 0 0",
          }}
        >
          <div>
            <h2
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "700",
                color: "#1f2937",
                textDecoration: "underline",
              }}
            >
              {selectedMember.member_id}
            </h2>
            <p
              style={{
                margin: "12px 0 0 0",
                fontSize: "14px",
                fontWeight: "500",
                color: "#357ABD",
              }}
            >
              CAFE24 관리자 ➡ 고객 ➡ 회원 관리 ➡{" "}
              <span style={{ fontWeight: "900" }}>회원 가입 인증</span>
              <span style={{ color: "#6b7280" }}> 에서 승인이 가능합니다</span>
            </p>
            <p
              style={{
                margin: "8px 0 -8px 0",
                fontSize: "14px",
                fontWeight: "500",
                color: "#EF5350",
              }}
            >
              ❗️ 승인 시)
              <span style={{ fontWeight: "900" }}> 회원 등급별 관리 ➡ </span>
              <span
                style={{
                  background: "#4A90E2",
                  color: "white",
                  padding: "4px 8px",
                  borderRadius: "4px",
                  fontSize: "13px",
                  fontWeight: "700",
                }}
              >
                {selectedMember.group}
              </span>{" "}
              으로 변경해주세요.
            </p>
          </div>
          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              fontSize: "28px",
              color: "#6b7280",
              cursor: "pointer",
              padding: "4px 10px",
              borderRadius: "8px",
              transition: "all 0.2s",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#f3f4f6";
              e.target.style.color = "#374151";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "transparent";
              e.target.style.color = "#6b7280";
            }}
          >
            ✕
          </button>
        </div>

        {/* 컨텐츠 */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          {/* 왼쪽: 회원 정보 */}
          <div
            style={{
              flex: 1,
              minWidth: "400px",
              padding: "24px 16px 24px 24px",
            }}
          >
            <div style={{ display: "grid", gap: "20px" }}>
              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  기업명
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                  }}
                >
                  {selectedMember.company_name || "-"}
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  사업자번호
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                    fontFamily: "monospace",
                  }}
                >
                  {selectedMember.business_number?.replace(
                    /(\d{3})(\d{2})(\d{5})/,
                    "$1-$2-$3"
                  ) || "-"}
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  대표자명
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                  }}
                >
                  {selectedMember.ceo_name || "-"}
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  담당자명
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                  }}
                >
                  {selectedMember.manager_name || "-"}
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  연락처
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                    fontFamily: "monospace",
                  }}
                >
                  {formatPhoneNumber(selectedMember.phone) || "-"}
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  실주소 (납품처 기준)
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                    lineHeight: "1.5",
                  }}
                >
                  {selectedMember.address || "-"}
                </div>
              </div>

              <div>
                <label
                  style={{
                    display: "block",
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#374151",
                    marginBottom: "6px",
                  }}
                >
                  세금계산서발행 이메일
                </label>
                <div
                  style={{
                    padding: "12px 16px",
                    backgroundColor: "#f8fafc",
                    borderRadius: "8px",
                    border: "1px solid #e2e8f0",
                    fontSize: "15px",
                    color: "#1f2937",
                    fontFamily: "monospace",
                  }}
                >
                  {selectedMember.email || "-"}
                </div>
              </div>
            </div>
          </div>

          {/* 오른쪽: 사업자등록증 사진 */}
          <div style={{ flex: "1", minWidth: "400px", padding: "8px" }}>
            <div
              style={{
                border: "1px solid #e2e8f0",
                overflow: "hidden",
                backgroundColor: "#f8fafc",
                width: "500px",
                //maxWidth: "100%",
                aspectRatio: "210 / 297", // A4 비율 (1:1.414)
                position: "relative",
              }}
            >
              {selectedMember.business_photo ? (
                <img
                  src={`https://bizlingtea.s3.ap-northeast-2.amazonaws.com/business_photo/${mallId}/${shopNo}/${selectedMember.business_photo}`}
                  alt="사업자등록증"
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    backgroundColor: "white",
                  }}
                  onError={(e) => {
                    e.target.style.display = "none";
                    e.target.nextSibling.style.display = "flex";
                  }}
                />
              ) : null}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  display: selectedMember.business_photo ? "none" : "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  color: "#6b7280",
                }}
              >
                <div style={{ fontSize: "48px", marginBottom: "12px" }}>📄</div>
                <p style={{ margin: 0 }}>사업자등록증이 없습니다</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberModal;
